import dayjs from 'dayjs';

/**
 * Converts a Firestore timestamp to a formatted date-time string
 * @param {Object} timestamp - Firestore timestamp object with seconds property
 * @returns {string} Formatted date-time string (YYYY-MM-DD HH:mm:ss)
 */
export const firestoreTimestampToDateTime = (timestamp) => {
    const seconds = timestamp?.seconds || 0;
    return dayjs.unix(seconds).format('YYYY-MM-DD HH:mm:ss');
};

/**
 * Formats various value types for display in the table
 * @param {*} value - The value to format
 * @returns {string} Formatted value
 */
export const formatValue = (value) => {
    if (value === null || value === undefined) return '-';

    // Firestore Timestamp-like object
    if (value && typeof value.seconds === 'number') {
        return firestoreTimestampToDateTime(value);
    }

    // Firestore Timestamp has toDate()
    if (value && typeof value.toDate === 'function') {
        return dayjs(value.toDate()).format('YYYY-MM-DD HH:mm:ss');
    }

    // JS Date
    if (value instanceof Date) {
        return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
    }

    // Otherwise return as-is (strings, numbers)
    return String(value);
};

/**
 * Gets a nested value from an object using dot notation
 * @param {Object} obj - The object to traverse
 * @param {string} path - Dot-separated path (e.g., 'user.profile.name')
 * @returns {*} The nested value or undefined
 */
export const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split('.').reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        obj
    );
};
